import { TypedActorNode } from "./_Base";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
export class BaseUserInputActorNode extends TypedActorNode {
  initializeNode() {
    const register = () => {
      this.scene().eventsDispatcher.registerActorNode(this);
    };
    const unregister = () => {
      this.scene().eventsDispatcher.unregisterActorNode(this);
    };
    this.lifecycle.onAfterAdded(register);
    this.lifecycle.onBeforeDeleted(unregister);
  }
}
class BaseUserInputActorParamsConfig extends NodeParamsConfig {
}
